<template>
  <div class="search-sort__header">
    <div class="search-sort__search">
      <input :placeholder="placeholder" v-model="modelValue.search">
      <svg-magnify-glass class="site-search-btn__icon"></svg-magnify-glass>
    </div>
    
    <div class="search-sort__sort">
      <button type="button" class="search-sort__sort-btn" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
        <span class="search-sort__sort-btn-icon">
          <svg-sort class="w-3"></svg-sort>
        </span>
        <span class="search-sort__sort-btn-title">{{ sortTitle }}</span>
      </button>

      <ul class="search-sort__list" role="listbox" aria-labelledby="listbox-label">
        <li v-for="(item, i) in sortMenu" :key="i" class="search-sort__list-item" :class="{'active':item.selected}" role="option" @click="handleSort(i, item.value)">
          <span class="search-sort__list-title">{{ item.title }}</span>
          <span v-if="item.selected" class="search-sort__list-selected">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
            </svg>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {

	props: {
    modelValue: {
      type: Object,
      default: {}
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    sortMenu: {
      type: Array,
      default: []
    }
	},

  mounted() {
    this.init();
  },

	data() {
		return {
      sortTitle: 'Sort'
		}
	},

	methods: {
    init() {
      this.sortMenu.forEach((el,i) =>  {
        if (el.value === this.modelValue.sort) {
          el.selected = true;
          this.sortTitle = el.title;
        }
      });
    },
    handleSort(idx, key) {
      this.sortMenu.forEach((el,i) =>  el.selected = (i === idx) ? true : false);
      this.sortTitle = this.sortMenu[idx].title;
      this.modelValue.sort = key;     
    }
	}
}
</script>
